/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsBlogCustom = {
  init: function($section){

    // Add settings from schema to current object
    window.PXUTheme.jsBlogCustom = $.extend(this, window.PXUTheme.getSectionData($section));

    this.element = $section[0];

    this.delegateElement = new domDelegate.Delegate(this.element);

    if(this.enable_filter == true) {
      this.handleTagButtons();
      this.delegateElement.on('click', '[data-tag-handle]', this.blogFilter.bind(this));
    }

  },
  handleTagButtons: function(){
    var tagButtons = document.querySelectorAll("[data-tag-handle]");
    var pathname = window.location.pathname;
    var pathnameValsArray = pathname.split("/");
    var tags = pathnameValsArray[pathnameValsArray.length-1];

    tagButtons.forEach(button => {
      var tagHandle = button.getAttribute("data-tag-handle");
      if (tags.indexOf(tagHandle) > -1) {
        button.classList.add("active");
      }
    });
  },
  blogFilter: function(event, target) {
    event.preventDefault()
    var buttonTagHandle = target.getAttribute("data-tag-handle")
    var pathname = window.location.pathname;
    var pathnameValsArray = pathname.split("/");

    if (pathnameValsArray.indexOf("tagged") > -1) {
      var tags = pathnameValsArray[pathnameValsArray.length-1];
      var tagsArray = tags.split("+");
      if (tagsArray.indexOf(buttonTagHandle) > -1) {
        var index = tagsArray.indexOf(buttonTagHandle);
        tagsArray.splice(index,1);
      } else {
        tagsArray.push(buttonTagHandle);
      }
      if (tagsArray.length == 0) {
        pathnameValsArray.splice(3,2);
        var newURL = pathnameValsArray.join("/");
      } else {        
        var newTagsString = tagsArray.join("+");
        pathnameValsArray.splice(pathnameValsArray.length-1, 1,newTagsString);
        var newURL = pathnameValsArray.join("/");
      }
      window.location = newURL;
    } else {
      var url = `/tagged/${buttonTagHandle}`;
      window.location = window.location.origin+window.location.pathname+url;
    }

  },
  unload: function($section) {
    
  }
}

/******/ })()
;